module.exports = __webpack_public_path__ + "static/img/home5.b4b482c1.png";